<template>
  <template v-if="Array.isArray(categories) && categories.length">
    <div class="px-2 sm:px-0 py-2">
      <div v-for="category in categories" :key="category.id" class="mb-2">
        <div class="font-semibold text-gray-700 mb-2">{{ category.name }}</div>
        <video-details-category-sub :subs="category.video_category_subs" />
      </div>
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { useStore } from '@/store/index'
import { VideoCategoryAttributes } from '@/types/models/video-category'

import VideoDetailsCategorySub from '@/components/VideoDetailsCategorySub.vue'

export default defineComponent({
  props: {
    categories: {
      type: Array as PropType<VideoCategoryAttributes[]>,
      'default': () => ([]),
    }
  },
  components: {
    VideoDetailsCategorySub
  },
  setup() {
    const store = useStore()

    return {
      store,
    }
  }
})
</script>
